import Checkbox from '@eversports/react-components/primitives/Checkbox'
import { SimpleFlex, VerticalFlex } from '@eversports/react-components/primitives/Flex'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import Text from '@eversports/react-components/primitives/Text'
import PyroForm from 'pyro-form'
import React, { useEffect, useState } from 'react'

import useCheckoutContext from '../../data/useCheckoutContext'
import { Localized } from '../../localization/react'
import { PaymentMethodVerificationMethod } from '../../typings/Payment'

interface InitialValues {
  hasUserAgreement: Array<string>
}

interface Props {
  verifyWith: PaymentMethodVerificationMethod
}

const SepaForm: React.FC<React.PropsWithChildren<Props>> = ({ verifyWith }) => {
  const context = useCheckoutContext()

  const [initialValues] = useState<InitialValues>({ hasUserAgreement: [] })

  const handleChange = (values: InitialValues) => {
    context.setIsPaymentValid(values.hasUserAgreement.length > 0)
  }

  useEffect(() => {
    context.setIsPaymentValid(false)
  }, [])

  return (
    <VerticalFlex verticalSpacing="default">
      {verifyWith !== PaymentMethodVerificationMethod.PAYMENT_METHOD_IDEAL && (
        <Text fontWeight="bold">
          <Localized id="pay-with-sepa" params={{ verifyWith }} />
        </Text>
      )}
      <SimpleFlex alignItems="flex-start">
        <Icon icon={Icons.INFO} size="large" color="subtleText" />
        <Text marginLeft="dense" size="small">
          <Localized id="sepa-verify-with-payment-information" params={{ verifyWith }} />
        </Text>
      </SimpleFlex>
      <PyroForm initialValues={initialValues} onChange={handleChange}>
        <Text>
          <Localized id="sepa-disclaimer" />
        </Text>
        <Checkbox value="true" name="hasUserAgreement" label={<Localized id="sepa-agreement" />} />
      </PyroForm>
    </VerticalFlex>
  )
}

export default SepaForm
